import { useMemo } from 'react'

import { Button, HStack, Icon } from '@chakra-ui/react'
import { AddIcon, CancelIcon, ResetIcon } from '@editor/assets/icons'
import { PanelType } from '@editor/config/constants'
import { BlueprintEditorTools } from '@editor/pages/projects/blueprint-editor/definitions'
import { setSelectedTool, toggleCollapsedPanel } from '@editor/pages/projects/blueprint-editor/store/blueprintEditor'
import { setAttentionText } from '@editor/pages/projects/common/AttentionText/store/attentionText'
import CollapsePanel from '@editor/pages/projects/editor/infoPanels/components/CollapsePanel'
import { resetWorking } from '@editor/pages/projects/editor/tools/MaskPCD/store'
import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { resetWorkingState } from '../store'

const MaskRegionPanel = () => {
  // Store
  const dispatch = useAppDispatch()
  const selectedTool = useSelector((state: RootState) => state.blueprint.editor.selectedTool)
  const isCreatingBlueprint = useSelector((state: RootState) => state.blueprint.editor.isCreatingBlueprint)
  const collapsedPanel = useSelector((state: RootState) => state.blueprint.editor.collapsedPanel)
  const workingMask = useSelector((state: RootState) => state.maskPCD.workingMask)

  const drawnPlanePoints = useSelector((state: RootState) => state.bpBlueprintCreator.drawnPlanePoints)

  // Derived
  const isModifyingMaskRegion = useMemo(() => selectedTool === BlueprintEditorTools.MaskPCD, [selectedTool])
  const isCollapsed = useMemo(() => collapsedPanel.includes(PanelType.Tool), [collapsedPanel])

  if (!isCreatingBlueprint) return null

  return (
    <CollapsePanel
      title="注目領域"
      onChange={() => dispatch(toggleCollapsedPanel(PanelType.Tool))}
      isCollapsed={isCollapsed}
    >
      <HStack w="100%" p={4}>
        {!isModifyingMaskRegion && !workingMask ? (
          <Button
            w="100%"
            variant="panel-dark-outline"
            fontWeight="normal"
            onClick={() => {
              dispatch(setSelectedTool(BlueprintEditorTools.MaskPCD))

              // If user has drawn some points but not enough to form a plane, reset the working state
              if (drawnPlanePoints.length && drawnPlanePoints.length < 3) {
                dispatch(resetWorkingState())
              }
            }}
          >
            <Icon as={AddIcon} boxSize={5} />
            追加
          </Button>
        ) : null}

        {!isModifyingMaskRegion && workingMask ? (
          <Button
            w="100%"
            variant="panel-dark-outline"
            fontWeight="normal"
            onClick={() => {
              dispatch(setSelectedTool(BlueprintEditorTools.BlueprintManager))
              dispatch(setAttentionText({ message: '' }))
              dispatch(resetWorking())
            }}
          >
            <Icon as={ResetIcon} boxSize={5} />
            リセット
          </Button>
        ) : null}

        {isModifyingMaskRegion ? (
          <Button
            variant="panel-dark-outline"
            borderColor="red.500"
            fontWeight="normal"
            w="100%"
            onClick={() => {
              // TODO: Add a confirmation modal before resetting

              dispatch(setSelectedTool(BlueprintEditorTools.BlueprintManager))
              dispatch(setAttentionText({ message: '' }))
              dispatch(resetWorking())
            }}
          >
            <Icon as={CancelIcon} color="red.500" boxSize={5} />
            キャンセル
          </Button>
        ) : null}
      </HStack>
    </CollapsePanel>
  )
}

export default MaskRegionPanel
